import script from "./DividendsViewWithId.vue?vue&type=script&setup=true&lang=ts"
export * from "./DividendsViewWithId.vue?vue&type=script&setup=true&lang=ts"

import "./DividendsViewWithId.vue?vue&type=style&index=0&id=4daf17b8&scope=true&lang=postcss"

const __exports__ = script;

export default __exports__